import type * as Types from '../../../../../shared/generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TogglePersonActivationMutationVariables = Types.Exact<{
  input: Types.TogglePersonActivationInput;
}>;

export type TogglePersonActivationMutation = {
  __typename?: 'Mutation';
  togglePersonActivation: {
    __typename?: 'TogglePersonActivationResponse';
    message: string;
    success: boolean;
  };
};

export const TogglePersonActivationDocument = gql`
  mutation TogglePersonActivation($input: TogglePersonActivationInput!) {
    togglePersonActivation(input: $input) {
      message
      success
    }
  }
`;
export type TogglePersonActivationMutationFn = Apollo.MutationFunction<
  TogglePersonActivationMutation,
  TogglePersonActivationMutationVariables
>;
export function useTogglePersonActivationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TogglePersonActivationMutation,
    TogglePersonActivationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TogglePersonActivationMutation,
    TogglePersonActivationMutationVariables
  >(TogglePersonActivationDocument, options);
}
export type TogglePersonActivationMutationHookResult = ReturnType<
  typeof useTogglePersonActivationMutation
>;
export type TogglePersonActivationMutationResult =
  Apollo.MutationResult<TogglePersonActivationMutation>;
export type TogglePersonActivationMutationOptions = Apollo.BaseMutationOptions<
  TogglePersonActivationMutation,
  TogglePersonActivationMutationVariables
>;
